import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitEnquiry = (data) => axios.post(`${API}/enquiries`, data);
export const subscribeNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email });

// ---- Packages (public) ----
export const fetchPackages = (type) =>
  axios.get(`${API}/packages`, { params: type ? { type } : {} }).then((r) => r.data);
export const fetchPackage = (slug) =>
  axios.get(`${API}/packages/${slug}`).then((r) => r.data);

// ---- Admin auth ----
const TOKEN_KEY = "ll_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeader = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password });
export const adminMe = () => axios.get(`${API}/auth/me`, authHeader());
export const getEnquiries = () => axios.get(`${API}/enquiries`, authHeader());
export const updateEnquiryStatus = (id, status) =>
  axios.patch(`${API}/enquiries/${id}`, { status }, authHeader());

// ---- Admin packages ----
export const createPackage = (data) => axios.post(`${API}/packages`, data, authHeader());
export const updatePackage = (id, data) => axios.put(`${API}/packages/${id}`, data, authHeader());
export const deletePackage = (id) => axios.delete(`${API}/packages/${id}`, authHeader());

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/upload`, fd, {
    headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" },
  });
};

// ---- Blogs (public) ----
export const fetchBlogs = () => axios.get(`${API}/blogs`).then((r) => r.data);
export const fetchBlog = (slug) => axios.get(`${API}/blogs/${slug}`).then((r) => r.data);

// ---- Admin blogs ----
export const createBlog = (data) => axios.post(`${API}/blogs`, data, authHeader());
export const updateBlog = (id, data) => axios.put(`${API}/blogs/${id}`, data, authHeader());
export const deleteBlog = (id) => axios.delete(`${API}/blogs/${id}`, authHeader());
